import { LanguagesTypes } from '@hydra/types';
import getHelpLink from '@hydra/utils/getHelpLink';
import getCoreWebVitalsLink from '@hydra/utils/getCoreWebVitalsLink';

import { sendEvent } from '@hydra/utils/gtm';
import { useEffect, useState, useCallback } from 'react';

// TODO: Re-enable Help Center once URL is updated
const SHOW_HELP_CENTER = false;

interface IOption {
  icon?: string,
  label: string,
  header?: boolean,
  link?: string,
  divider?: boolean,
  gtmLabel?: string
}
export default function useContactSupport (language: LanguagesTypes): {
  options: IOption[],
  isHelpLoading: boolean,
  onClick: () => void
} {
  const options: IOption[] = [
    ...(
      SHOW_HELP_CENTER
        ? [
            {
              icon: 'help',
              label: 'help_dropdown_item_help_center',
              link: getHelpLink(language),
              divider: true,
              gtmLabel: 'topnav-dropdown-help-center-link'
            }
          ]
        : []),
    {
      label: 'help_dropdown_header_resources',
      header: true
    },
    {
      icon: 'information',
      label: 'help_dropdown_item_seo_guides',
      link: `/${language}/edu/seo-guides`,
      gtmLabel: 'topnav-dropdown-seo-guides-link'
    },
    {
      icon: 'http-status',
      label: 'help_dropdown_item_cwv',
      link: getCoreWebVitalsLink(language),
      gtmLabel: 'topnav-dropdown-cwv-link'
    },
    {
      icon: 'page-content',
      label: 'help_dropdown_item_help_blog',
      link: `/${language}/blog`,
      gtmLabel: 'topnav-dropdown-blog-link'
    }
  ];
  const [helpIsLoading, setHelpIsLoading] = useState<boolean>(false);
  const [helpVisible, setHelpVisible] = useState<boolean>(false);
  const [fallback, setFallback] = useState<any>({});

  function init () {
    sendEvent('gtm-click-help');
    setHelpIsLoading(true);
    if (!helpVisible) {
      setFallback(setTimeout(() => {
        sendEvent('gtm-click-help-fallback');
        window.location.href = `/${language}/help`;
      }, 5000));
    }
  }
  const handleEvents = useCallback(() => {
    window.addEventListener('gtm-help-opened', () => {
      clearTimeout(fallback);
      setHelpIsLoading(false);
      setHelpVisible(true);
    });

    window.addEventListener('gtm-help-closed', () => {
      setHelpIsLoading(false);
      setHelpVisible(false);
    });
  }, [fallback]);

  useEffect(() => {
    handleEvents();
  }, [handleEvents]);
  return {
    options,
    isHelpLoading: helpIsLoading,
    onClick: init
  };
}
